import { createSelector } from 'reselect';
import { compare } from './../utility/CompareUtils';

const Company = 'company';

const selectCompanies = (state) => state.get(Company).get('companies');
const getCompanies = createSelector(selectCompanies, (data) => {
  const sortedList = data.sort((a, b) => compare(a.get('name'), b.get('name')));
  return sortedList;
});

const selectIsLoading = (state) => state.get(Company).get('isLoading');
const getLoadingStatus = createSelector(selectIsLoading, (data) => data);

const selectActionResponse = (state) => state.get(Company).get('actionResponse');
const getCompanyActionResponse = createSelector(selectActionResponse, (data) => data);

export { getCompanies, getLoadingStatus, getCompanyActionResponse };
